import { Url } from '@repo/types/Types';
import React from 'react';
import { ButtonLink } from '../Elements/Button';
import { Mercury } from '@repo/types/Models';
interface MainViewProps {
  loading?: boolean;
  children?: React.ReactNode;
  title?: string;
  accountName?: Mercury.Models.Account['name'];
  description?: string | React.ReactNode;
  cta?: false | { cta: true; ctaHref: Url; ctaText: string };
  admin?: boolean;
}

export const MainView = ({
  children,
  title,
  accountName,
  description,
  loading,
  cta,
  admin,
}: MainViewProps) => {
  return (
    <main className="relative px-2 pb-24 mx-auto w-full h-full pt-30 sm:pt-36 sm:px-10 md:px-20 max-w-[1600px]">
      <div className="flex justify-between gap-4 flex-wrap mb-10 w-full">
        {loading ? (
          <div className="flex items-center mb-4 w-64 h-full animate-pulse">
            <div className="w-full h-10 rounded bg-grey-400 dark:bg-grey-800"></div>
          </div>
        ) : (
          <div className="flex flex-col">
            {title && (
              <h1 className="mb-2 text-2xl font-bold sm:text-4xl dark:text-blue-100 text-grey-1000 break-all">
                {title}
              </h1>
            )}

            {admin && (
              <span className="mb-4 text-3xl text-grey-700 dark:text-grey-400">
                {accountName ? `Account: ${accountName}` : accountName === '' ? '' : 'NO ACCOUNT'}
              </span>
            )}

            {loading ? (
              <div className="flex flex-col gap-2 w-full max-w-xl h-full animate-pulse">
                <div className="w-full h-4 rounded bg-grey-400 dark:bg-grey-800"></div>
                <div className="w-full max-w-sm h-4 rounded bg-grey-400 dark:bg-grey-800"></div>
              </div>
            ) : (
              <div>
                {description && (
                  <p
                    className="dark:text-blue-100"
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                )}
              </div>
            )}
          </div>
        )}

        {cta && <ButtonLink href={cta.ctaHref}>{cta.ctaText}</ButtonLink>}
      </div>

      <div className="flex flex-col gap-12">{children}</div>
    </main>
  );
};
